/** The words every register shares: the search, the export, the count, the empty and failed states. */
export const REGISTER_COPY = {
    searchPlaceholder: 'Search…',
    export: 'Export',
    entries: (shown: number, total: number) =>
        shown === total
            ? `${total} ${total === 1 ? 'entry' : 'entries'}`
            : `${shown} of ${total} entries`,
    empty: {
        title: 'No entries yet',
        body: 'New entries will appear here.',
    },
    noMatch: {
        title: 'No entries match',
        body: 'Nothing in this register matches the search.',
        action: 'Clear search',
        filtersBody: 'Nothing in this register matches these filters.',
        filtersAction: 'Clear filters',
    },
    failed: {
        title: 'This register could not be loaded',
        body: 'A problem reading the list. Nothing has been changed, and your filters are still set.',
        action: 'Try again',
    },
} as const;
